import { render, staticRenderFns } from "./DowngradComponentesDialog.vue?vue&type=template&id=1f9171a6&scoped=true"
import script from "./DowngradComponentesDialog.vue?vue&type=script&lang=js"
export * from "./DowngradComponentesDialog.vue?vue&type=script&lang=js"
import style0 from "./DowngradComponentesDialog.vue?vue&type=style&index=0&id=1f9171a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9171a6",
  null
  
)

export default component.exports